<script lang="ts">
  import InspectorField from '../InspectorField.svelte';
  import ConfirmDialog from '../../ui/ConfirmDialog.svelte';
  import { patchZone, deleteZone } from '$lib/api';
  import { clearEntity } from '$lib/router';
  import { zonesQuery } from '$lib/queries/zones';
  import { roomsQuery } from '$lib/queries/rooms';
  import { invalidateAfterZoneCreate, invalidateAfterZoneDelete } from '$lib/state/invalidation';
  import { router } from '$lib/router';

  let { id }: { id: number } = $props();

  const zones = zonesQuery();
  const rooms = roomsQuery();

  let zone = $derived((zones.data ?? []).find((z) => z.id === id));
  let roomCount = $derived(zone ? (rooms.data ?? []).filter((r) => r.zone === zone.id).length : 0);

  let showDeleteConfirm = $state(false);

  async function saveName(name: string) {
    await patchZone(id, { name });
    invalidateAfterZoneCreate(router.unitId!);
  }

  async function handleDelete() {
    showDeleteConfirm = false;
    if (!zone) return;
    await deleteZone(zone.id);
    invalidateAfterZoneDelete(router.unitId!);
    clearEntity();
  }
</script>

{#if zone}
  <div class="px-3 py-3 space-y-4">
    <div class="space-y-2">
      <InspectorField label="Name" value={zone.name} onSave={saveName} />

      <div class="space-y-1">
        <p class="text-2xs font-medium text-text-muted uppercase tracking-wide">Room count</p>
        <p class="text-sm font-mono text-text-primary">{roomCount}</p>
      </div>
    </div>

    <div class="pt-4 border-t border-border-default space-y-2">
      <p class="text-2xs font-medium text-text-muted uppercase tracking-wide">Danger zone</p>
      <button
        type="button"
        class="w-full px-2 py-1.5 text-sm text-state-error border border-state-error/30 rounded hover:bg-state-error/5 transition-colors duration-100"
        onclick={() => (showDeleteConfirm = true)}
      >
        Delete zone
      </button>
    </div>
  </div>
{:else}
  <div class="px-3 py-3 text-sm text-text-muted">Zone not found</div>
{/if}

<ConfirmDialog
  bind:open={showDeleteConfirm}
  title="Delete zone"
  message="Delete “{zone?.name}”? All rooms in this zone will also be removed."
  confirmText="Delete"
  onconfirm={handleDelete}
  oncancel={() => (showDeleteConfirm = false)}
/>
